// extracted by mini-css-extract-plugin
export default {"container":"MsgMeta_container__XibcO","item":"MsgMeta_item__nDTXG","title":"MsgMeta_title__9RuF0","tos":"MsgMeta_tos__UcKsP"};